import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { StateType } from "../../../../utils/types";
import { setNextStep } from "../../../../redux/shared/actions";
import { assignCourse, getCourse } from "../../../../redux/educator/actions";
import {
  selectCourses,
  selectCoursesLoading,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  courses: selectCourses(state),
  loading: selectCoursesLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      setNextStep,
      assignCourse,
      getCourse,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
